import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

type IconSize = 'xs' | 's' | 'm' | 'l' | 'xl' ;
type IconVariant =
  | 'default'
  | 'light'
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'disabled'
  | 'dark';

@Component({
  selector: 'idh-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'cssClass()',
  },
})
export class IconComponent {
  readonly name = input.required<string>();
  readonly size = input<IconSize>('m');
  readonly variant = input<IconVariant>('default');
  readonly ariaLabel = input<string | null>(null);
  readonly stroke = input<boolean>(false);

  private readonly spritePath = '/assets/sprite/icons.svg';
  readonly useRef = computed(() => `${this.spritePath}#${this.name()}`);

  readonly ariaHidden = computed(() => (this.ariaLabel() ? null : 'true'));

  readonly cssClass = computed(() => {
    const base = 'idh-icon';
    const sizeClass = `${base}--${this.size()}`;
    const variant = `${base}--${this.variant()}`;
    const stroke = this.stroke() ? `${base}--stroke` : '';
    return [base, sizeClass, variant, stroke].filter(Boolean).join(' ');
  });
}
